module.exports = __webpack_public_path__ + "static/map1-879b3f93dcfbab9262bf8ad4d9855d2d.png";